import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  root: {
    width: '448px',
    border: `2px dashed ${theme.palette.default.contrastText}`,
    color: theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '90px',
    '& p': {
      fontSize: theme.typography.fontSize + 4,
      color: theme.palette.grey['400'],
      fontWeight: theme.typography.fontWeightBold,
      fontFamily: theme.typography.fontFamily,
      margin: '12px 0',
    },
    '& .upload-left-icon': {
      marginLeft: '25px',
      marginTop: '10px',
    },
    '& .upload-right-text': {
      marginRight: '60px',
    },
    '& .upload': {
      stroke: theme.palette.default.contrastText,
      fill: 'white',
      width: '60px',
    },
    '& .principal-text': {
      color: theme.palette.default.contrastText,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.fontSize + 2,
      lineHeight: '19px',
      margin: '0px',
      cursor: 'pointer',
    },
    '& .secondary-text': {
      color: theme.palette.default.contrastText,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.fontSize,
      lineHeight: '19px',
      margin: '0px',
      cursor: 'pointer',
    },
  },
  'root--has-file': {
    backgroundColor: theme.palette.purple['50'],
    border: `2px dashed ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '& p': {
      fontSize: theme.typography.fontSize + 10,
      color: theme.palette.primary.main,
    },
  },
})

export default useStyles
